import React, { useEffect } from 'react'
import RenderEditorContentAsHtml from './BlockEditor/RenderEditorContentAsHtml';
import { Block } from "@blocknote/core"

type BlockType = "paragraph" | "heading" | "image" | "list" | "numberedListItem";

interface InlineContent {
  text: string;
  bold?: boolean;
  italic?: boolean;
}

interface ContentItem {
    text: string,
    type: string
}

export interface IBlock {
  type: BlockType;
  props?: {
    text?: string;
    textAlignment?: "left" | "center" | "right";
    url?: string;
    alt?: string;
  };
  children?: InlineContent[] | IBlock[],
  content?: ContentItem[]
}

const renderInline = (inline: InlineContent): JSX.Element | string => {
    if (inline.bold) return <strong>{inline.text}</strong>;
    if (inline.italic) return <em>{inline.text}</em>;
    return inline.text;
  };

const renderBlock = (block: IBlock, key: number): JSX.Element | null => {
    switch (block.type) {
      case "paragraph":
        return (
          <p key={key} style={{ textAlign: block.props?.textAlignment || "left" }}>
            {block.content?.map((child, index) =>
              typeof child === "object" ? renderInline(child as InlineContent) : child
            )}
          </p>
        );
  
      case "heading":
        return <h1 key={key}>{block.content?.[0].text}</h1>;
  
      case "image":
        return (
          <img
            key={key}
            src={block.props?.url}
            alt={block.props?.alt || "Image"}
            style={{ maxWidth: "100%" }}
          />
        );
  
      case "list":
        return (
          <ul key={key}>
            {block.children?.map((child, index) =>
              typeof child === "object" ? (
                <li key={index}>{renderInline(child as InlineContent)}</li>
              ) : (
                <li key={index}>{child}</li>
              )
            )}
          </ul>
        );
  
      default:
        return null; // For unsupported block types
    }
  };

interface IProps {
    blocks: IBlock[]
}

export default function RenderBlockEditor(props: IProps) {

    const { blocks } = props

    return <RenderEditorContentAsHtml blocks={(blocks as Block[])} />
    // useEffect(() => {
    //     console.log("blocks", blocks)
    // }, [blocks])

    // return(
    //     <div className="block-editor-rendered-blocks">
    //         {blocks.map((block, index) => renderBlock(block, index))}
    //     </div>
    // )
}